// src-dev/ts/components/scroll-animations.ts
// Fade-in al hacer scroll, con dirección alternada por sección

interface AnimConfig {
    selector: string;
    direction: 'left' | 'right' | 'up' | 'down';
  }
  
  const SECTIONS: AnimConfig[] = [
    { selector: '#section-about',     direction: 'left'  },
    { selector: '#section-works-done',        direction: 'up'    },  // works-done tiene lógica propia por fila
    { selector: '#section-services',         direction: 'right' },
    { selector: '#section-clients',          direction: 'up'    },
    { selector: '#section-contact',          direction: 'left'  },
  ];
  
  const TRANSLATE: Record<AnimConfig['direction'], string> = {
    left:  'translateX(-60px)',
    right: 'translateX(60px)',
    up:    'translateY(60px)',
    down:  'translateY(-60px)',
  };
  
  function applyInitial(el: HTMLElement, direction: AnimConfig['direction']): void {
    el.style.opacity = '0';
    el.style.transform = TRANSLATE[direction];
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
  }
  
  function reveal(el: HTMLElement): void {
    el.style.opacity = '1';
    el.style.transform = 'none';
  }
  
  // Secciones generales: anima la sección completa
  function initSectionFades(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reveal(entry.target as HTMLElement);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
  
    SECTIONS.forEach(({ selector, direction }) => {
      const el = document.querySelector<HTMLElement>(selector);
      if (!el) return;
      applyInitial(el, direction);
      observer.observe(el);
    });
  }
  
  // works-done: cada fila alterna izquierda/derecha, con up al salir de pantalla
  function initWorksFades(): void {
    const rows = document.querySelectorAll<HTMLElement>('#section-works-done .obra-row');
    if (!rows.length) return;
  
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reveal(entry.target as HTMLElement);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
  
    rows.forEach((row, i) => {
      // Alterna: par → desde izquierda, impar → desde derecha
      const direction: AnimConfig['direction'] = i % 2 === 0 ? 'left' : 'right';
      applyInitial(row, direction);
      observer.observe(row);
    });
  }
  
  export function initScrollAnimations(): void {
    initSectionFades();
    initWorksFades();
  }